import {
    CHANGE_APPOINTMENT_DATE,
    GET_APPOINTMENT, GET_APPOINTMENT_CHANGE_DATE, RESET_VALUES, SET_LONG_TOKEN, SET_UPDATE_TOKEN,
} from '../constants/actionTypes'

const initialState = {};

const appointmentDateChangeReducer = (state = initialState, action) => {

    //console.log("action---",action);
    switch (action.type) {
        case GET_APPOINTMENT_CHANGE_DATE:
            return {
                ...state,
                editAppointment: action.payload,
            };
        case SET_UPDATE_TOKEN:
            return {
                ...state,
                longToken: action.payload,
            };
        case CHANGE_APPOINTMENT_DATE:
            return {
                ...state,
                appointment_date: action.payload
            };
        case RESET_VALUES:
            return {
                ...state,
                appointment_date:null
            }
        default:
            return state;
    }
};

export default appointmentDateChangeReducer;